<template>
  <v-card
    height="100%"
    :to="{
      name: 'payments',
      params: {
        paymentCardType: 0,
        dateType: 1,
      },
    }"
  >
    <v-card-title>
      <v-icon large color="black" class="mr-2">$paylink</v-icon>
      <span>{{ $t("paymentLinks") }}</span></v-card-title
    >
    <v-card-text class="px-4">
      <v-progress-circular
        v-if="loading"
        class="py-4 mx-auto d-block"
        indeterminate
        color="primary"
        :size="50"
        :width="7"
      ></v-progress-circular>
      <template v-else>
        <span class="font-weight-bold text-h4">
          <ul class="plain-list">
            <li
              v-for="item in paylinkItems"
              :key="item.name"
              class="d-flex justify-space-between"
            >
              <span class="text-h5 font-weight-bold">{{
                $t(item.name.toLowerCase())
              }}</span>
              <v-spacer></v-spacer>
              <span>
                {{ item.count }}
              </span>
            </li>
          </ul>
        </span>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PayLinkMetrics",
  props: {
    paylinkItems: {
      required: true,
      type: Array,
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
};
</script>
